import { zodResolver } from "@hookform/resolvers/zod";
import {
    Box,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import BasicDialog from "../../components/base/BasicDialog";
import { useToasts } from "../../hooks/useToasts";
import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";

import { useEditCustomerSymfoniaCodeMutation } from "../../services/customersService";

export const customerSchema = z
    .object({
        customer_symfonia_code: z.string()
    })

export function EditCustomerSymfoniaCodeDialog(props) {
    const { id, customerName, customerSymfoniaCode } = props;
    
    const { handleSubmit, control, formState, register, reset, setValue, watch } = useForm({
        resolver: zodResolver(customerSchema),
        defaultValues: {
            customer_symfonia_code: customerSymfoniaCode
        },
    });

    const isFormValid = watch("customer_symfonia_code")

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: updateCustomer, isPending } = useEditCustomerSymfoniaCodeMutation({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEdited")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });


    // Update form values 
    useEffect(() => {
        if (customerSymfoniaCode) {
            reset({customer_symfonia_code: customerSymfoniaCode})
        }
    }, [customerSymfoniaCode, reset]);


    const onSubmit = (data) => {
        updateCustomer({id, data})
    };   

    // if (isLoading) {
    //     return (
    //         <BasicDialog
    //             open={props.open}
    //             onClose={props.onClose}
    //             titleAlign={"center"}
    //             contentAlign={"center"}
    //             title="Loading..."
    //             maxWidth={"xs"}
    //             showDialogActions
    //             alwaysFullScreen={false}
    //         >
    //             <Box display="flex" justifyContent="center" p={4}>
    //                 <CircularProgress />
    //             </Box>
    //         </BasicDialog>
    //     );
    // }

    return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                showTitle={true}
                title={t("bankings.edit_customer_symfonia_code")}
                maxWidth={"xs"}
            >
                <Grid container rowSpacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            value={customerName}
                            fullWidth
                            disabled={true}
                            label={t("bankings.customer_name")}
                            size="small"
                            sx={{background: "white"}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            {...register("customer_symfonia_code")}
                            fullWidth
                            disabled={false}
                            label={t("bankings.symfonia_code")}
                            size="small"
                            sx={{background: "white"}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isPending}
                            disabled={isPending}
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            onClick={handleSubmit(onSubmit, onFormErrors)}
                            fullWidth
                        >
                            {t("edit")}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </BasicDialog>
        );
}
